export default "__VITE_ASSET__BENHlCKx__"